/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const walletInvoiceTopUpDataSchema = z.object({
	amount: z.number(),
	note: z.string().nullable().optional(),
	customFields: z.array(z.object({ id: z.string().uuid(), value: z.string() })).nullable().optional(),
	profileId: z.string().uuid().nullable().optional(),
})

export type WalletInvoiceTopUpDataSchema = z.infer<typeof walletInvoiceTopUpDataSchema>
